var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"cbd8bc2d4c5286e63db1493e79bdc6f3ec3df769"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["storefront@otovo"]={id:"cbd8bc2d4c5286e63db1493e79bdc6f3ec3df769"};
      